import { Spinner } from '@optools/components/loading/spinner';
import { cn } from '@optools/components/ui/utils';

export interface PageLoaderProps {
  className?: string;
  withDelay?: boolean;
}

export function PageLoader({ className, withDelay = false }: PageLoaderProps) {
  return (
    <div
      className={cn(
        'absolute top-0 left-0 flex h-full w-full flex-1 items-center justify-center opacity-0',
        withDelay ? 'animate-fade-in delay-1000' : 'opacity-100',
        className,
      )}>
      <Spinner className="size-10" />
    </div>
  );
}
